const graphicPackingBasePath = '/graphic-packings';

const GraphicPackingConst = {
   basePath: graphicPackingBasePath,
};

export default GraphicPackingConst;